<!--start::Body-->
<div class="overlay overlay-block cursor-default modal-body">
  <div class="d-flex flex-column justify-content-center text-center">
    <span class=""><mat-icon color="primary">error_outline</mat-icon></span>
    <h2 class="font-weight-bolder my-5">Are you sure?</h2>
    <span class="text-dark-500">
      Do you want to go through the coach marks again?
    </span>
  </div>
</div>
<!--end::Body-->
<div class="modal-footer">
  <div>
    <button type="button" class="btn btn-pill btn-light px-11 mr-1" (click)="modal.dismiss()"
      [disabled]="(reseting$ | async)">
      Cancel
    </button>&nbsp;
    <button type="button" class="btn btn-pill btn-primary text-dark px-12" (click)="reset()"
      [disabled]="(reseting$ | async)" [ngClass]="{'spinner spinner-white spinner-right' : (reseting$ | async)}">
      Reset
    </button>
  </div>
</div>